import { Icon } from '@garnet/ui';

export interface DropProps {
  label: string;
  hint: string;
  done: boolean;
  required?: boolean;
  onDrop: () => void;
}

/** Upload affordance — a click stands in for a file picker in this offline demo. */
export function Drop({ label, hint, done, required = false, onDrop }: DropProps) {
  return (
    <button
      type="button"
      onClick={onDrop}
      aria-pressed={done}
      style={{
        textAlign: 'left',
        width: '100%',
        border: `1px dashed ${done ? 'var(--verified)' : 'var(--rule)'}`,
        borderRadius: 'var(--radius-md)',
        padding: '14px 16px',
        cursor: 'pointer',
        display: 'flex',
        alignItems: 'center',
        gap: 12,
        background: done ? 'var(--verified-bg)' : 'var(--panel)',
        font: 'inherit',
      }}
    >
      <span style={{ color: done ? 'var(--verified-ink)' : 'var(--muted)', display: 'flex' }}>
        <Icon name={done ? 'check' : 'upload'} size={18} />
      </span>
      <span>
        <span style={{ fontSize: 13.5, fontWeight: 500 }}>
          {label}
          {required && <span style={{ color: 'var(--flag)', marginLeft: 4 }}>*</span>}
        </span>
        <span style={{ display: 'block', fontFamily: 'var(--mono)', fontSize: 11, color: 'var(--muted)', marginTop: 2 }}>
          {done ? 'uploaded · pending review' : hint}
        </span>
      </span>
    </button>
  );
}
